import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * Event fires when user successfully login on the portal (any login method).
 * @memberOf Playtech.API.events
 * @event auth:generic_login:success
 * @type {callback}
 * @example Playtech.on('auth:generic_login:success', () => { ... });
 */

export const EVENT_GENERIC_LOGIN = 'auth:generic_login:success';

export const useOnGenericLogin = (eventTarget: EventTarget) => {
    const handleEvent = useCallback((): void => {
        const event = new CustomEvent(EVENT_GENERIC_LOGIN);

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on(EVENT_GENERIC_LOGIN, handleEvent);

        return () => publicEventsAPIService.off(EVENT_GENERIC_LOGIN, handleEvent);
    }, [handleEvent]);
};
